import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserService } from '../../services/user.service';
import { DinamictextService } from '../../services/dinamictext.service';
import { LocationService } from '../../services/location.service';
import { DinamicData, Cell } from '../../models/dinamic-data';
import { Methods } from '../../shared/methods';
import swal from 'sweetalert2';
interface location{
  id: number;
  name: string;
}
@Component({
  selector: 'app-visitorlink',
  templateUrl: './visitorlink.component.html',
  styleUrls: ['./visitorlink.component.css'],
  providers: [ LocationService , UserService ]
})

export class VisitorlinkComponent implements OnInit {

  public mtds: Methods = new Methods();

  selectedFile: File;
  public identity;
  public link: string;

  public savingPolicy = false;
  public policy = '';
  public policy_id = null;

  public savingPrivacy = false;
  public privacy = '';
  public privacy_id = null;

  public savingAbout = false;
  public about = '';
  public about_id = null;

  public companyLinkedData;
  public userlogged;
  public token
  public Locations: location[] = [
  ];
  selectedLocationId: number = 3;
  constructor(
    private _locationService: LocationService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _userService: UserService,
    private _dinamicTextService: DinamictextService
    ) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.link = `https://dashboard.itaderp.com/pages/login/${this.identity.apiCompany}/${this.selectedLocationId}`;

    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

    this._userService.getUser(this.token, this.identity.sub).subscribe(
      response => {
        console.log(response);
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if(response.status == 'success') {
            this.userlogged = response.data;
            this.companyLinkedData = this.userlogged.companyLinked;
            this.companyLinkedData.imgFile = this.companyLinkedData.imgBackgroundFile ? 'https://itaderp.com/backend/resources/'+this.companyLinkedData.imgBackgroundFile : '';
        }
      },
      error => {
        console.log(<any>error);
      }
    );

    this._dinamicTextService.list('VISITORSPOLICY').subscribe(
      r => {
        console.log(r);

        if (r.data.length) {
          this.policy_id = r.data[0].id;
          this.policy = r.data[0].data;
        }
      }
    );

    this._dinamicTextService.list('PRIVACYPOLICY').subscribe(
      r => {
        console.log(r);

        if (r.data.length) {
          this.privacy_id = r.data[0].id;
          this.privacy = r.data[0].data;
        }
      }
    );

    this._dinamicTextService.list('ABOUTUS').subscribe(
      r => {
        console.log(r);

        if (r.data.length) {
          this.about_id = r.data[0].id;
          this.about = r.data[0].data;
        }
      }
    );
    this.locationselect();
  }

  ngOnInit() {
  }
  //Location Star
  locationselect() {
    this._locationService.getLocations(this.token).subscribe(
      response => {
        if (response.code === 400 && response.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (response.status === 'success') {
          for (let i = 0; i < response.data.length; i++) {
            const data = response.data[i];
            const location = { id: data.id, name: data.name };
            this.Locations.push(location);
          }
        } else {
          this.showSwal('error', 'ERROR!', response.msg);
          console.log(response.msg)
        }
      },
      error => {
        console.log(<any>error);
        this.showSwal('error');
      }
    );
  }
  updateLink(locationId: number) {
    this.link = `https://dashboard.itaderp.com/pages/login/${this.identity.apiCompany}/${locationId}`;
  }
  showSwal(type, title = '', message = '') {
    if (type === 'success') {
          swal.fire({
          
              title: title,
              text: message,
              buttonsStyling: false,
           customClass:{
    confirmButton: 'btn btn-success'
            },

          });

      } else if (type === 'error') {
        swal.fire({
        
          title: title,
          text: message,
          buttonsStyling: false,
       customClass:{
    confirmButton: 'btn btn-success'
            },

        });
      }
  }
  //Location END

  onFileChanged(event) {
    var xhr = new XMLHttpRequest();
    this.selectedFile = <File>event.target.files[0];
    let headers = new Headers({'Content-Type':'multipart/form-data'});

    const uploadData = new FormData();
    uploadData.append('namefile', this.selectedFile, this.selectedFile.name);
    uploadData.append('apitoken', this.identity.apiCompany);
    uploadData.append('type', 'PROFILEIMGBACKGROUND');
    console.log(uploadData);

    xhr.onreadystatechange = () => {
      if(xhr.readyState == 4){
        if(xhr.status == 200){
          //  console.log(xhr.response);
          let respuesta = JSON.parse(xhr.response);
          console.log(respuesta.status);
          console.log(respuesta.img);
          this.companyLinkedData.imgFile = 'https://itaderp.com/backend/resources/'+respuesta.img;
          } else {
            console.log(xhr.response);
          }
        }
      }
    xhr.open('POST', 'https://itaderp.com/backend/resources/receiver.php', true);
    //xhr.setRequestHeader('Authorization',token);
    xhr.send(uploadData);
  }

  savePolicy() {
    this.savingPolicy = true;
    this._dinamicTextService.save(this.policy_id, 'VISITORSPOLICY', this.policy).subscribe(
      r => {

        console.log(r);

        if (r.code === 400 && r.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (r.status === 'success') {
          this.policy_id = r.data.id;
          swal.fire({
        
            title: 'Done!',
            text: `Policy Text has been successfully updated`,
            buttonsStyling: false,
            customClass:{
    confirmButton: 'btn btn-success'
            },
          });
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }

        this.savingPolicy = false;
      }, error => {
        this.savingPolicy = false;
      }
    );
  }

  saveAboutus() {
    this.savingAbout = true;
    this._dinamicTextService.save(this.about_id, 'ABOUTUS', this.about).subscribe(
      r => {

        console.log(r);

        if (r.code === 400 && r.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (r.status === 'success') {
          this.about_id = r.data.id;
          swal.fire({
           
            title: 'Done!',
            text: `About us Text has been successfully updated`,
            buttonsStyling: false,
            customClass:{
    confirmButton: 'btn btn-success'
            },
          });
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }

        this.savingAbout = false;
      }, error => {
        this.savingAbout = false;
      }
    );
  }

  savePrivacity() {
    this.savingPrivacy = true;
    this._dinamicTextService.save(this.privacy_id, 'PRIVACYPOLICY', this.privacy).subscribe(
      r => {

        console.log(r);

        if (r.code === 400 && r.msg === 'Authorization not valid') {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        } else if (r.status === 'success') {
          this.privacy_id = r.data.id;
          swal.fire({
         
            title: 'Done!',
            text: `Privacity Policy Text has been successfully updated`,
            buttonsStyling: false,
           customClass:{
    confirmButton: 'btn btn-success'
            },
          });
        } else {
          this.mtds.notifyError(r.msg, r.code);
        }

        this.savingPrivacy = false;
      }, error => {
        this.savingPrivacy = false;
      }
    );
  }

}
